import { Action, createReducer, on } from '@ngrx/store';
import { ProcessOutcome } from '@wdx/clmi/clmi-swagger-gen';
import { CrudState, CrudStateObject } from '@wdx/clmi/api-services/models';
import { CrudStatus } from '@wdx/shared/utils';
import * as outcomesActions from './outcomes.actions';

export interface ShowRequireFormResult {
    correlationId: string;
    success?: boolean;
}

export interface State {
    workItemOutcomes: CrudStateObject<ProcessOutcome>;
    showRequireFormResult: ShowRequireFormResult[];
}

export const initialState: State = {
    workItemOutcomes: {},
    showRequireFormResult: [],
};

const reducerSetup = createReducer(
    initialState,

    on(
        outcomesActions.setOutcomeForWorkItem,
        (state, props): State => ({
            ...state,
            workItemOutcomes: {
                ...state.workItemOutcomes,
                [props.workItemId]: {
                    ...(state.workItemOutcomes[props.workItemId] ||
                        ({} as CrudState<ProcessOutcome>)),
                    isUpdating: true,
                    hasUpdatingError: false,
                    status: CrudStatus.Loading,
                },
            },
        }),
    ),

    on(
        outcomesActions.setOutcomeForWorkItemSuccess,
        (state, props): State => ({
            ...state,
            workItemOutcomes: {
                ...state.workItemOutcomes,
                [props.workItemId]: {
                    ...state.workItemOutcomes[props.workItemId],
                    isUpdating: false,
                    hasUpdatingError: false,
                    status: CrudStatus.Success,
                },
            },
        }),
    ),

    on(
        outcomesActions.setOutcomeForWorkItemFailure,
        (state, props): State => ({
            ...state,
            workItemOutcomes: {
                ...state.workItemOutcomes,
                [props.workItemId]: {
                    ...state.workItemOutcomes[props.workItemId],
                    isUpdating: false,
                    hasUpdatingError: true,
                    status: CrudStatus.Error,
                },
            },
        }),
    ),

    on(
        outcomesActions.setShowRequireFormResult,
        (state, props): State => ({
            ...state,
            showRequireFormResult: [
                ...state.showRequireFormResult.filter(
                    (result) => result.correlationId !== props.correlationId,
                ),
                { correlationId: props.correlationId, success: props.success },
            ],
        }),
    ),
);

export function reducer(state: State | undefined, action: Action) {
    return reducerSetup(state, action);
}
